import { password } from './password'
import { passwordless } from './passwordless'
import { singleAuth } from './single-auth'
import { signup } from './signup'
import { review } from './review'
import { context } from './context'
import { selectClaim } from './select-claim'

const state = {
  password,
  passwordless,
  singleAuth,
  signup,
  review,
  context,
  selectClaim,
}

export { state }
